import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import Vuelidate from 'vuelidate'
import './assets/css/base.scss';
import Axios from 'axios';
import store from './store'
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

import './assets/css/bootstrap-float-label.css';
import './assets/css/modal.css';

require('@/store/subscribe.js');

if(window.location.hostname == 'baraybar.pampadev.com.ar'){
  Axios.defaults.baseURL = "https://apibaraybar.pampadev.com.ar/api";
}else{
Axios.defaults.baseURL = "http://localhost:8000/api";
}

Vue.config.productionTip = false
store.dispatch('getUser', localStorage.getItem('token'));
store.dispatch('setInstitucion', JSON.parse(localStorage.getItem('institucion')));
if (localStorage.getItem('institucion') != "null") {
    Axios.defaults.headers.common['institucionId'] = JSON.parse(localStorage.getItem('institucion')).id;
}

Vue.use(Vuelidate);


const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
    moment
})


Vue.filter('cuil', function(value) {
    if (!value) return ''
    value = value.toString()
    if (value.length == 11) {
        let values = value.split("");
        values.splice(2, 0, "-");
        values.splice(11, 0, "-");
        return values.join("");
    }
    return value;

})
Vue.filter('numFormat', numFormat(numeral));

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')